export default __webpack_public_path__ + "static/media/Monger-HUD-Pop-Up (Process) 4in1.076c2e6c.jpg";